import { Paper, useMediaQuery } from '@mui/material'
import Grid from '@mui/material/Grid2'
import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { BalanceDialog } from '../../../dialogs/BalanceDialog'
import { PaymentFailedDialog } from '../../../dialogs/PaymentFailedDialog/PaymentFailedDialog'
import { PaymentSuccessfulDialog } from '../../../dialogs/PaymentSuccessfulDialog/PaymentSuccessfuDialog'
import { useProfileStore } from '../../../store/storeProfile'
import { theme } from '../../../theme'
import { PaymentStatus } from '../../../types/billing'
import { ReferralBlock } from '../ProfilePage/components/ReferralBlock'
import { Billing } from './components/billing/Billing'
import { PackageListCard } from './components/PackageListCard'
import { RecurringPayment } from './components/RecurringPayment'
import { Storage } from './components/Storage'

export const FinancesPage = () => {
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))
    const [searchParams, setSearchParams] = useSearchParams()
    const [openPaymentDialog, setOpenPaymentDialog] = useState<boolean>(false)
    const [openPaymentSuccessfulDialog, setOpenPaymentSuccessfulDialog] = useState<boolean>(false)
    const [openPaymentFailedDialog, setOpenPaymentFailedDialog] = useState<boolean>(false)

    const {
        fetchTariffList,
        fetchRecurringPayment,
        userTariff,
        recurringPayment,
        fetchStorageTariffs,
        fetchStorageTariffUser,
    } = useProfileStore((state) => state)

    useEffect(() => {
        fetchTariffList()
        fetchRecurringPayment()
        fetchStorageTariffs()
        fetchStorageTariffUser()
    }, [])

    useEffect(() => {
        const paymentStatus = searchParams.get('paymentStatus')

        if (
            recurringPayment &&
            recurringPayment.is_active !== true &&
            paymentStatus === PaymentStatus.SUCCESS
        ) {
            ym(100275765, 'reachGoal', 'purchaseAA_successful')
            setOpenPaymentSuccessfulDialog(true)
        }

        if (paymentStatus === PaymentStatus.ERROR) {
            ym(100275765, 'reachGoal', 'purchaseAA_error')
            setOpenPaymentFailedDialog(true)
        }

        if (searchParams.get('isOpenTariffDialog') === 'true') {
            setOpenPaymentDialog(true)
        }
    }, [searchParams, recurringPayment])

    const handleClosePaymentDialog = () => {
        setOpenPaymentDialog(false)
    }
    const handleClickOpenPaymentDialog = () => {
        setOpenPaymentDialog(true)
    }

    const handleClosePaymentSuccessfulDialog = () => {
        setOpenPaymentSuccessfulDialog(false)
    }
    const handleClosePaymentFailedDialog = () => {
        setOpenPaymentFailedDialog(false)
    }

    return (
        <>
            <PackageListCard />
            <Grid container spacing={1}>
                {userTariff?.tariff?.title !== 'Бесплатный' && (
                    <Grid size={{ xs: isMobile ? 12 : 6 }}>
                        <RecurringPayment open={() => setOpenPaymentSuccessfulDialog(true)} />
                    </Grid>
                )}

                <Grid
                    size={{ xs: userTariff?.tariff?.title === 'Бесплатный' || isMobile ? 12 : 6 }}>
                    <ReferralBlock />
                </Grid>
                <Grid size={12}>
                    <Storage />
                </Grid>
            </Grid>

            <Paper>
                <Grid sx={{ height: 'auto', overflowY: 'auto' }}>
                    <Billing />
                </Grid>
            </Paper>

            <PaymentSuccessfulDialog
                type={
                    searchParams.get('paymentStatus') === PaymentStatus.SUCCESS
                        ? 'success'
                        : recurringPayment?.is_active
                          ? 'change'
                          : 'connect'
                }
                open={openPaymentSuccessfulDialog}
                handleClose={handleClosePaymentSuccessfulDialog}
            />
            <PaymentFailedDialog
                open={openPaymentFailedDialog}
                handleClose={handleClosePaymentFailedDialog}
                handleOpenPaymentDialog={handleClickOpenPaymentDialog}
            />
            <BalanceDialog open={openPaymentDialog} handleClose={handleClosePaymentDialog} />
        </>
    )
}
